import React, { useEffect, useMemo, useRef, useState } from 'react'
import {
  Row,
  Col,
} from 'tea-component';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import Accumulate from '@/pages/dashboard/components/Accumulate';
import moment from 'moment';
import PerformanceMetricsTable from '@/pages/dashboard/components/PerformanceMetricsTable';
import SelectShowValueType from '../../../overview/components/OverviewTable/components/SelectShowValueType';
import './index.scss'
import { generateCopyData, getDynamicLocalCnEnText } from '@/pages/dashboard/utils/utils';
import { useSelector } from 'umi';
import DimensionAccumulateRow from '@/pages/dashboard/components/DimensionAccumulateRow';
const OverallPerformance = (props: any) => {
  const {
    title,
    columns,
    tableData,
    timeType,
    selectType,
    loading,
    error,
    gameCode,
    sortValue,
    tablePaging,
    accumulation: accumulationProps,
    setSelectType,
    onUpdate,
    onColumnChange,
    accumulationList,
    handleDownload,
    frontLogicalFlag,
    overLimitBarTriggerKey,
  } = props
  const { metrics_list, row_count, average: svgList } = tableData
  const { isEN, locale, getLocalText } = useLocal();
  const [accumulation, setAccumulation] = useState(accumulationProps)
  const [total, setTotal] = useState(row_count);
  const accumulateOldValueRef = useRef(accumulationProps)
  const {selector} = useSelector(state => state?.dashboardSetting ?? {})

  const {
    data,
    pageTotal,
    tableCopyData
  } = useMemo(() => {
    if (!metrics_list || !metrics_list.length) {
      return {
        data: [],
        pageTotal: 0
      }
    }
    let tData: any[] = []
    let copyData: any[] = []
    const timeTypeMap: any = {
      daily: 'YYYY-MM-DD',
      weekly: 'YYYY-MM-DD',
      monthly: 'YYYY-MM'
    }

    //console.log('表格数据---------', metrics_list);
    // 处理表格基本数据
    metrics_list.forEach((item: any) => {
      const temp: any = {}
      temp['date'] = moment(item.date).format(timeTypeMap[timeType]);
      temp['by_channel'] = item.channel_name;
      temp['by_country'] = item.country_name;
      temp['by_network'] = item.network_name;
      temp['by_region'] = item.region_name;
      temp['by_system'] = item.system_name;
      Object.keys(item.metrics || {}).forEach(k => {
        temp[k] = item.metrics[k].value
        temp[k + '_dod'] = item.metrics[k].dod
      })
      const generateCpd = generateCopyData(temp, {gameCode, selectorList: selector})
      copyData.push({...temp, ...generateCpd})
      tData.push(temp)
    })
    // 处理表格svg数据
    svgList?.forEach((item: any, index: any) => {
      const temp: any = {}
      temp['date'] = [ getLocalText('ua_Sum'), getLocalText('common_Average')][index]
      temp['by_channel'] = item.channel_name;
      temp['by_country'] = item.country_name;
      temp['by_network'] = item.network_name;
      temp['by_region'] = item.region_name;
      temp['by_system'] = item.system_name;

      Object.keys(item.metrics || {}).forEach(k => {
        temp[k] = item.metrics[k].value
        temp[k + '_dod'] = item.metrics[k].dod
      })
      tData.push(temp)
    })

    return{
      data: tData,
      pageTotal: row_count,
      tableCopyData: copyData
    }
  }, [tableData,locale])

  useEffect(() => {
    setTotal(row_count)
  }, [row_count])

  return (
    <Row>
      <Col span={24}>
        <PerformanceMetricsTable
          className='dbd-date-contrast-table dbd-ua-performance-table tableCompare'
          isNewSort
          title={title}
          timeType={timeType}
          topTip={{
            left: (<div className="overall-conext-bottom">
              <DimensionAccumulateRow
                className='register-table-select margin-r-20'
                value={accumulation}
                options={accumulationList}
                onChange={(value) => {
                  setAccumulation(value);
                  const flag = accumulateOldValueRef?.current?.toString() !== value?.toString();
                  if (flag) {
                    accumulateOldValueRef.current = value;
                    onUpdate({
                      accumulation:value,
                      tablePaging: { pageIndex: 1, pageSize: 10 },
                      sortValue: []
                    },true)
                  }
                }}
              />
              <SelectShowValueType
                value={selectType}
                onChange={(value) => {setSelectType?.(value)}}
                isShowDod={true}
              />
            </div>)
          }}
          columns={columns ?? []}
          copyConfig={
            {
              copyTitleList:['copy time','current','copy current and time'],
              copyData:tableCopyData?? []
            }
          }
          records={data ?? []}
          selectType={selectType}
          loading={loading}
          isError={error}
          // isShowProgressBar
          onDownload={handleDownload}
          sorting={
            {
              config: {
                value: sortValue,
              },
              defaultSorts: sortValue,
              onSortChange:(sorts)=> {
                onUpdate({
                  sortValue: sorts
                })
              }
            }
          }
          paging={{
            pageIndex: tablePaging?.pageIndex,
            pageSize: tablePaging?.pageSize,
            recordCount: total,
            onPagingChange: (paging?: any) => {
              onUpdate({
                tablePaging: paging
              })
            }
          }}
          onResizeEnd={(columns) => onColumnChange(columns)}
          height={527}
          frontLogicalFlag={frontLogicalFlag}
          overLimitBarTriggerKey={overLimitBarTriggerKey}
        />
      </Col>
    </Row>
  )
}

export default OverallPerformance
